import React from 'react';
import { Row, Col, Typography, Spin, Avatar, Empty } from 'antd';
import { RobotOutlined, UserOutlined } from '@ant-design/icons';
import moment from 'moment';
import SimpleMarkdown from '../../components/SimpleMarkdown';

const { Text, Paragraph, Title } = Typography;

const primaryBlue = '#0851B5';
const aiAvatarBg = '#2C82F6 ';
const lightBg = '#F6F6F6';

const InformationTab = ({ sessionData }) => {
  if (!sessionData) {
    return (
      <div style={{ padding: '16px', textAlign: 'center' }}>
        <Spin />
      </div>
    );
  }

  const chatLog = sessionData.rawChat || [];

  return (
    <Row gutter={[24, 16]}>
      <Col span={12}>
        <div style={{ padding: '16px' }}>
          <Row gutter={[16, 24]}>
            <Col span={24}>
              <Text strong style={{ color: primaryBlue }}>Session</Text><br />
              <Text>{sessionData.sessionId || 'N/A'}</Text>
            </Col>
            <Col span={24}>
              <Text strong style={{ color: primaryBlue }}>Site Name</Text><br />
              <Text>{sessionData.siteName || 'N/A'}</Text>
            </Col>
            <Col span={12}>
              <Text strong style={{ color: primaryBlue }}>Start Date</Text><br />
              <Text>
                {sessionData.sessionStart
                  ? moment(sessionData.sessionStart).format('hh:mm:ss A, MMM DD, YYYY')
                  : 'N/A'}
              </Text>
            </Col>
            <Col span={12}>
              <Text strong style={{ color: primaryBlue }}>End Date</Text><br />
              <Text>
                {sessionData.sessionEnd
                  ? moment(sessionData.sessionEnd).format('hh:mm:ss A, MMM DD, YYYY')
                  : 'N/A'}
              </Text>
            </Col>
            <Col span={24}>
              <Text strong style={{ color: primaryBlue }}>Summary</Text><br />
              <Paragraph style={{ whiteSpace: 'pre-wrap' }}>
                <SimpleMarkdown>{sessionData.sessionSummary || 'N/A'}</SimpleMarkdown>
              </Paragraph>
            </Col>
          </Row>
        </div>
      </Col>

      <Col span={12}>
        <Title level={5} style={{ padding: '0 16px', color: primaryBlue }}>Conversation Log</Title>
        <div style={{ padding: '16px', maxHeight: '60vh', overflowY: 'auto', background: '#ffffff', borderRadius: '8px' }}>
          {chatLog.length > 0 ? chatLog.map((msg) => (
            <div key={msg.createdAt} style={{ marginBottom: '16px', display: 'flex', flexDirection: msg.role === 'user' ? 'row-reverse' : 'row' }}>
              <Avatar
                style={{
                  backgroundColor: msg.role === 'assistant' ? aiAvatarBg : '#ccc',
                  marginRight: msg.role === 'assistant' ? '8px' : '0',
                  marginLeft: msg.role === 'user' ? '8px' : '0',
                  flexShrink: 0,
                }}
                icon={msg.role === 'assistant' ? <RobotOutlined /> : <UserOutlined />}
              />
              <div
                style={{
                  padding: '8px 20px',
                  borderRadius: '10px',
                  background: msg.role === 'assistant' ? lightBg : aiAvatarBg,
                  color: msg.role === 'assistant' ? '#000000' : '#ffffff',
                  maxWidth: '70%',
                  boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                <SimpleMarkdown>{msg.content || ''}</SimpleMarkdown>
                <Text
                  type="secondary"
                  style={{
                    display: 'block',
                    fontSize: '0.75em',
                    textAlign: msg.role === 'user' ? 'right' : 'left',
                    marginTop: '8px',
                    color: msg.role === 'assistant' ? '#e0e0e0' : '#595959',
                  }}
                >
                  {msg.createdAt ? moment(msg.createdAt).format('hh:mm A') : ''}
                </Text>
              </div>
            </div>
          )) : <Empty description="No conversation log available." />}
        </div>
      </Col>
    </Row>
  );
};

export default InformationTab;
